<template>
  <div v-if="errorMessageList.length" class="errorArea">
    <!-- toBエラーの時 -->
    <div v-if="isToBeError(resultCode)">
      <p
        v-for="errorMessage in errorMessageList"
        :key="errorMessage"
        class="errorMessage__toB"
        v-html="errorMessage"
      ></p>
      <p class="errorMessage__noEmail">別のメールアドレスをお持ちでない場合</p>
      <span class="errorMessage__linkWrapper">
        <a
          href="/rnet/info/notice/index02.html"
          target="_blank"
          class="errorMessage__createAccountLink"
          @click="sendLoginClickLog($event)"
          >新規作成方法はこちら
        </a>
      </span>
    </div>
    <!-- toBエラー以外の時 -->
    <div v-else>
      <p v-for="errorMessage in errorMessageList" :key="errorMessage" class="errorMessage">{{ errorMessage }}</p>
    </div>
  </div>
</template>

<script>
import { sendLog } from '../../../helper/_sendLog';

export default {
  name: 'ErrorMessage',
  props: {
    errorMessageList: {
      type: Array,
      required: false,
      default: () => [],
    },
    resultCode: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  methods: {
    isToBeError(resultCode) {
      return resultCode === 3;
    },
    sendLoginClickLog(event) {
      const log = `${trace_p}_toberror_click`;
      sendLog(s, event.target, log);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../css/contents/common/global';

.errorArea {
  background-color: #fff2f2;
  border-radius: 4px;
  min-height: 45px;
  width: 100%;
  box-sizing: border-box;
  padding: 12px;
}

.errorMessage {
  color: #e62525;
  font-size: $text-size-paragraph2;
  font-weight: $text-weight-bold;
  line-height: $text-line-height-default;
  white-space: pre-wrap;
}

.errorMessage__toB {
  color: #e62525;
  font-size: $text-size-paragraph2;
  font-weight: 400;
  line-height: $text-line-height-default;
  white-space: pre-wrap;
  border-bottom: #d3d4d4 1px solid;
  padding-bottom: 12px;
  margin-bottom: 12px;
}

// APIレスポンスの文字列内に含まれるクラス
::v-deep .errorMessage__createAccount {
  font-weight: 700;
}

.errorMessage__noEmail {
  text-align: center;
  font-size: $text-size-paragraph2;
  font-weight: 400;
  line-height: $text-line-height-default;
  padding-bottom: 4px;
}

.errorMessage__linkWrapper {
  display: flex;
  justify-content: center;
}

.errorMessage__createAccountLink {
  display: flex;
  align-items: center;
  color: $color-action-primary;
  font-size: $text-size-paragraph2;
  font-weight: 700;
  line-height: $text-line-height-default;

  &::after {
    content: '';
    display: inline-block;
    width: 8px;
    height: 12px;
    background-image: url('/images/s/arrow_blue_bold.png');
    background-size: 8px 12px;
    background-repeat: no-repeat;
    margin-top: -1px;
    margin-left: 4px;
  }
}
</style>
